import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MX_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#MX_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 0h10v24H22V0z",
      fill: "#D9071E"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h12v24H0V0z",
      fill: "#006923"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 0h12v24H10V0z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.056 8.341c-.106.456-.037.563.477.563.027 0 .069.076.115.158.05.09.105.188.15.203-.02.025-.215.378-.216 1 0 .128.06.339.117.542.062.22.121.43.098.514-.038.136-.208-.012-.34-.127-.075-.065-.137-.12-.156-.104-.094.079-.142-.547-.171-.925-.014-.169-.023-.288-.03-.274a.968.968 0 01-.06-.25c-.029-.19-.057-.376-.282-.376h-.58v.427s.335 0 .335.794c.006.12.163 1.164.543 1.17-.223.004-.221.049-.22.075v.005c0 .639.534.708 1.033.527.3-.108.619-.32.857-.58.337-.369.379-.846-.063-1.107-.158-.093-.329-.13-.567-.143.047-.14.002-.265-.033-.362-.029-.082-.051-.144-.007-.18.5-.406.545-.78.181-1.116-.047-.044-.093-.103-.14-.164-.089-.114-.182-.235-.3-.27.054-.109.128-.242.22-.395l-.858-.514c-.155.258-.13.461-.107.637.013.097.024.186.004.272zm.932 2.667l-.015.016.01-.01a.042.042 0 01.005-.006zm-.453.313h.001l.01-.002a.204.204 0 00-.01.002h-.001zm0 0zm-.435.334h-.034.034z",
      fill: "#A8AC71"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.383 7.913s-.686.533-.558 1.1c.128.569 1.482 0 1.318-.55-.163-.55-.76-.55-.76-.55z",
      fill: "#FCCA3D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.266 12.402s.925-2.74-.546-4.16c-1.47-1.419-3.17-1.324-3.17-1.324s-.489.364 0 .64c.49.278.285.544.285.544s-.82-.832-1.363-.346c-.544.486.507.412.396.778-.111.366-.583 1.991.106 2.812.69.82-.651.642-.379.642.273 0 1.24.191 1.24 0 0-.19.336.743.624.743s.51-.329.51-.329.403.329.649.329c.245 0 1.102-.215 1.102-.215L17.1 11.15s.098-.601-.131-.732c-.23-.13 1.841 1.155 2.004 1.57.162.413.293.413.293.413z",
      fill: "#8F4620"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.066 11.727s.15-.479.311-.512c.14-.029.432.23.432.23.52 2.889 1.779 4.018 3.866 4.018 2.112 0 3.392-.858 4.139-3.523 0 0 .397-.406.537-.36.152.048.343.585.343.585-.857 3.058-2.476 4.419-5.02 4.419-2.567 0-4.01-1.54-4.608-4.857z",
      fill: "#9FAB2F"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.335 13.656s3.004.638 4.19.638c1.186 0-1.04.967-1.91.967-.38 0-.837-.23-1.373-.69-.096-.083-.003-.268-.296-.27-.408-.004-.915-.1-.867-.158.046-.056.64-.072.583-.133-.094-.1-.327-.354-.327-.354z",
      fill: "#2FC2DC"
    }
  ), /* @__PURE__ */ e.createElement(
    "rect",
    {
      x: 14.666,
      y: 14.1,
      width: 2,
      height: 1.071,
      rx: 0.167,
      fill: "#F9AA51"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.176 12.136s0-.375.254-.574c.29-.229.564 0 .564 0 1.066 1.518 2.66 2.018 4.888 1.496 0 0 .666.218.7.361.042.182-.473.613-.473.613-2.605.61-4.618-.022-5.933-1.896z",
      fill: "#259485"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.592 12.35s-1.214.639-.81.639c.405 0 1.989.319 1.68 0-.308-.32-.87-.64-.87-.64zM15.157 11.588s-.23-.666-.71-.666-.345.546-.576.546c-.23 0 .215.385.414.385.199 0 .872-.265.872-.265z",
      fill: "#FCCA3D"
    }
  ))
), d = t;
export {
  d as default
};
